import { RootState } from "../../../redux-store";

export const selectNotifications = (state: RootState) =>
  state.app.notifications;
